/* Clyne custom interactions: add-to-cart helpers, set builder, popup, modals, delivery estimate */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.toggle('visually-hidden', count === 0);
      var c = b.querySelector('.cart-bubble__text-count');
      if (c) { c.textContent = count; c.classList.toggle('hidden', count === 0); }
    });
  }

  async function render(html) {
    if (!html) {
      var r = await fetch(root + '?sections=cart-drawer-section');
      var j = await r.json();
      html = j['cart-drawer-section'];
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.cart-drawer__inner');
    var cur = document.querySelector('#cart-drawer .cart-drawer__inner');
    if (!fresh || !cur) { window.location.href = root + 'cart'; return; }
    cur.replaceWith(document.importNode(fresh, true));
    try { var cart = await (await fetch(root + 'cart.js')).json(); updateBubble(cart.item_count); } catch (e) {}
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function' && !d.isOpen) d.open();
  }

  async function add(items) {
    var r = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer-section' })
    });
    var data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    await render(data.sections && data.sections['cart-drawer-section']);
    return data;
  }

  window.ClyneCart = { add: add, render: render };

  /* Any button with data-cl-add='variantId,variantId' adds those variants */
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-cl-add]');
    if (!btn) return;
    var ids = String(btn.getAttribute('data-cl-add') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try { await add(ids.map(function (id) { return { id: Number(id), quantity: 1 }; })); }
    catch (err) { alert(err.message); }
    finally { btn.classList.remove('is-loading'); }
  });

  /* Size pickers inside [data-cl-set]: one [data-cl-group] per product */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-cl-variant]');
    if (!s) return;
    var set = s.closest('[data-cl-set]');
    var group = s.closest('[data-cl-group]');
    if (!set || !group) return;
    group.querySelectorAll('[data-cl-variant]').forEach(function (b) { b.setAttribute('aria-pressed', b === s ? 'true' : 'false'); });
    var groups = set.querySelectorAll('[data-cl-group]');
    var ids = [], total = 0;
    groups.forEach(function (g) {
      var sel = g.querySelector('[aria-pressed=true]');
      if (sel) { ids.push(sel.getAttribute('data-cl-variant')); total += Number(sel.getAttribute('data-price') || 0); }
    });
    var submit = set.querySelector('[data-cl-set-submit]');
    if (!submit) return;
    var ready = ids.length === groups.length;
    submit.disabled = !ready;
    submit.setAttribute('data-cl-add', ready ? ids.join(',') : '');
    submit.textContent = ready ? submit.getAttribute('data-ready') + ' · ' + fmt(total) : submit.getAttribute('data-empty');
  });

  /* Modals (size guide) */
  function closeModal(m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cl-modal-open]');
    if (o) {
      var m = document.getElementById(o.getAttribute('data-cl-modal-open'));
      if (m) { if (m.parentNode !== document.body) document.body.appendChild(m); m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); }
      return;
    }
    var open = e.target.closest('[data-cl-modal]');
    if (open && (e.target === open || e.target.closest('[data-cl-modal-close]'))) closeModal(open);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-cl-modal].is-open').forEach(closeModal);
  });

  /* Delivery estimate + cut-off countdown (UK time, working days) */
  function ord(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  function day(d) { return MONTHS[d.getMonth()] + ' ' + ord(d.getDate()); }
  function addWorkdays(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function tick() {
    document.querySelectorAll('[data-cl-cutoff]').forEach(function (el) {
      var hour = Number(el.getAttribute('data-cl-cutoff'));
      var min = Number(el.getAttribute('data-min') || 1);
      var max = Number(el.getAttribute('data-max') || 3);
      var uk = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
      var cut = new Date(uk); cut.setHours(hour, 0, 0, 0);
      var wd = uk.getDay() > 0 && uk.getDay() < 6;
      var sameDay = wd && uk < cut;
      var dispatch = sameDay ? uk : addWorkdays(uk, 1);
      var title = el.querySelector('[data-cl-cutoff-title]');
      var sub = el.querySelector('[data-cl-cutoff-text]');
      if (title) title.textContent = 'Delivery ' + day(addWorkdays(dispatch, min)) + ' – ' + day(addWorkdays(dispatch, max));
      if (!sub) return;
      if (sameDay) {
        var mins = Math.floor((cut - uk) / 60000);
        sub.innerHTML = 'Order within <strong>' + String(Math.floor(mins / 60)).padStart(2, '0') + 'h ' + String(mins % 60).padStart(2, '0') + 'm</strong> ' + el.getAttribute('data-today');
      } else {
        sub.textContent = el.getAttribute('data-later');
      }
    });
  }

  /* Email popup */
  function initPopup() {
    var p = document.querySelector('[data-cl-popup]');
    if (!p) return;
    var key = 'cl_popup_seen';
    var days = Number(p.getAttribute('data-days') || 7);
    function open() { p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); }
    function close() { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
    p.addEventListener('click', function (e) { if (e.target === p || e.target.closest('[data-cl-popup-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && p.classList.contains('is-open')) close(); });
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(p)) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(p)) p.classList.remove('is-open'); });
    if (p.querySelector('[data-cl-posted]')) { open(); try { localStorage.setItem(key, String(Date.now() + 3650 * 864e5)); } catch (e) {} return; }
    if (window.Shopify && Shopify.designMode) return;
    var seen = 0;
    try { seen = Number(localStorage.getItem(key) || 0); } catch (e) {}
    if (seen && Date.now() - seen < days * 864e5) return;
    setTimeout(open, Number(p.getAttribute('data-delay') || 5) * 1000);
  }

  function init() { initPopup(); tick(); setInterval(tick, 30000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('variant:update', function () { setTimeout(tick, 50); });
})();
